module.exports = __webpack_public_path__ + "img/settings-other.7de819dc.svg";